import { render, staticRenderFns } from "./MduiNumberInput.vue?vue&type=template&id=bc633e4e&scoped=true"
import script from "./MduiNumberInput.vue?vue&type=script&lang=js"
export * from "./MduiNumberInput.vue?vue&type=script&lang=js"
import style0 from "./MduiNumberInput.vue?vue&type=style&index=0&id=bc633e4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc633e4e",
  null
  
)

export default component.exports